webpackJsonp([133514623493662],{

/***/ 811:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Webpack = __webpack_require__(24);
	
	var _Webpack2 = _interopRequireDefault(_Webpack);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Webpack2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Verifying Production Build Locally'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If we want to verify the production build of your application locally, you can do that easily using the ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/tj/serve' },
	        'serve'
	      ),
	      ' package, which allows you to serve files from any folder you choose on your computer.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To install it, run this command:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      npm install -g serve\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Then generate a development build of the application using this command:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      npm run build:development\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Then tell ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'serve'
	      ),
	      ' to serve the files out of that directory using this command:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      serve dist --port 3000\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'At this point you can navigate to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'localhost:3000'
	      ),
	      ' to view the production version of your application, but using the development configuration for the project.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-webpack-misc-serve-js-50e3715b335464b18f4e.js